//获取当前页面的宽度和高度
export function getWindowHeight() {
    console.log(window.outerHeight);
    return window.outerHeight;
}

export function getWindowWidth() {
    return window.outerWidth;
}